import React from 'react';
import { useSearchPanel } from 'features/search';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';

export const SearchPanel: React.FC = () => {
  const { value, isEnabledSearch, handleOnChange, handleSetIsEnabled, handleCancelSearch } = useSearchPanel();

  return (
    <div className="search-panel">
      <div className={`search-panel__container ${isEnabledSearch ? 'has-cancel' : ''}`}>
        <Input
          value={value}
          onChange={handleOnChange}
          placeholder="Search products"
          size="large"
          className="search-panel__container__input"
          prefix={<SearchOutlined className="search-panel__container__icon" />}
          onFocus={() => handleSetIsEnabled(true)}
        />
        <Button
          type="text"
          size="large"
          className={`search-panel__container__button ${isEnabledSearch ? 'is-visible' : ''}`}
          onClick={handleCancelSearch}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};
